import { PersonalDataFormWrapper } from './personal-data-form-wrapper';
import { MasterLayout } from 'layouts/master';
import { Route, Routes } from 'react-router-dom';

export const PersonalDataPage = () => {
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route path=":userUid" element={<PersonalDataFormWrapper />} />
      </Route>
    </Routes>
  );
};
